module.exports = {
  PAGE_SIZE_RENDER: 20,
  LAST_PAGE_VALUE: '...',
  PAGE_SIZE_TWELVE_RENDER: 15,
  PER_PAGE_TEN :10,
};
